import {Button,Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import Lang from "../../../components/Lang";
import DateChoice from "../../../components/DateChoice";
import { useState } from "react";
import mut from "../../../hooks/mut.ts";
import { StudentType } from "../types.ts";

type Attendance = {

}


type AddMakeUpProps = {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    student: StudentType,
    htClass: string,
    add: (attendance:Attendance) => void,
    
}


export default function AddMakeupDialog({ open, setOpen, student, htClass, add }: AddMakeUpProps) {
    const [dt, setDt] = useState("")
    
    const addClass = async() => {
        let res = await mut(`/attendance-add-makeup/${student._id}`, { classDate: dt, htClass: htClass, });
        add(res)
        setOpen(false)
        setDt("")
    }

  return (
    <Dialog
      open={open}
      fullWidth
    >
      <DialogTitle>
        <Lang w="addMakeupClass" />
      </DialogTitle>
      <div></div>
      <DialogContent className="h-20">
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 ">
          <DateChoice
            value={dt}
            setValue={setDt}
            label="Date of makeup class"
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
        <Button
          color="success"
                  disabled={!dt}
                  onClick={addClass}
        >
          Go
        </Button>
      </DialogActions>
    </Dialog>
  );
}